import React from "react";

export default function DownloadIcon() {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.25 9L9 11.25M9 11.25L6.75 9M9 11.25L9 2.25"
          stroke="#455468"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.625 6.75V6.75C3.76104 6.75 2.25 8.26104 2.25 10.125L2.25 11.75C2.25 13.9591 4.04086 15.75 6.25 15.75L11.75 15.75C13.9591 15.75 15.75 13.9591 15.75 11.75L15.75 10.125C15.75 8.26104 14.239 6.75 12.375 6.75V6.75"
          stroke="#455468"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
